import { useLocation } from 'react-router-dom';
import AppHeader from '../components/AppHeader';
import { useLang, useT } from '../i18n';
import { L } from '../redesign/tokens';
import { MIN_QUERY } from '../redesign/searchFormat';
import SearchResultsView from '../redesign/SearchResultsView';
import { useSearch } from '../redesign/useSearch';
import { useViewportKind } from '../redesign/useViewport';

// The Search results page (redesign step 2; dev website only, see lib/redesign.js): /search. The term arrives from the search bar in the
// router's in-memory state, never in the address (so it is not in browser history or access logs), and it goes to the backend in a POST
// body. Without it (a link, a new tab) the page shows the "type a search" state.
const PADDING = { wide: '32px 48px 48px', laptop: '32px 40px 48px', tablet: '28px 28px 48px', phone: '20px 16px 104px' };

export default function SearchResults() {
  const t = useT();
  const { lang } = useLang();
  const kind = useViewportKind();
  const { state } = useLocation();
  const q = (state && typeof state.q === 'string' ? state.q : '').trim().slice(0, 64);
  const { status, data, query } = useSearch(q, { mode: 'page', delay: 0 });
  const answered = status === 'ready' && data && query === q;
  const note = { fontSize: 16, color: L.muted };

  return (
    <div style={{ minHeight: '100vh', background: L.bg, color: L.text, fontFamily: L.sans, display: 'flex', flexDirection: 'column' }}>
      <AppHeader />
      <main style={{ flexGrow: 1, boxSizing: 'border-box', padding: PADDING[kind], display: 'flex', flexDirection: 'column', gap: 22 }}>
        {q.length === 0 && <div style={note} data-testid="results-start">{t('search.start')}</div>}
        {q.length > 0 && q.length < MIN_QUERY && <div style={note} data-testid="results-hint">{t('search.tooShort')}</div>}
        {q.length >= MIN_QUERY && status === 'error' && <div role="alert" style={note} data-testid="results-error">{t('search.error')}</div>}
        {q.length >= MIN_QUERY && status !== 'error' && !answered && <div style={note} data-testid="results-loading">{t('search.loading')}</div>}
        {answered && data.matches === 0 && <div style={note} data-testid="results-none">{t('search.none', { q })}</div>}
        {answered && data.matches > 0 && <SearchResultsView q={q} data={data} t={t} lang={lang} kind={kind} />}
      </main>
    </div>
  );
}
